// extracted by mini-css-extract-plugin
export var blogCopy = "TotLifeBlog-module--blogCopy--mzqBN";
export var blogImage = "TotLifeBlog-module--blogImage--3qCcJ";
export var buyNowButton = "TotLifeBlog-module--buyNowButton--6s6bT";
export var container = "TotLifeBlog-module--container--UZHOv";
export var headerCopy = "TotLifeBlog-module--headerCopy--xblm4";
export var relatedBlogs = "TotLifeBlog-module--relatedBlogs--RjFo4";
export var topics = "TotLifeBlog-module--topics--qF23H";